import React, { Component } from 'react';
import CurrencyInput from 'react-currency-input'; //https://github.com/jsillitoe/react-currency-input#readme
import autoBind from "react-autobind";
import N from '@common/constraints/numbers.contraints';

class DecimalInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value ?? 0
    }

    autoBind(this);
  }

  handleChange(evt, maskedValue) {
    const formattedValue = typeof(maskedValue) == 'string' ?
                           maskedValue.replace(/\./g, '').replace(',', '.') :
                           `${maskedValue}`;
  
    let floatValue = parseFloat(formattedValue);

    if(isNaN(floatValue) || typeof(floatValue) != 'number')
      floatValue = 0;
  
    this.setState({ value: floatValue }, () => {
      if(this.props.onValueChange)
        this.props.onValueChange({ maskedValue, floatValue });
    });
  }

  componentDidUpdate(prevProps) {
    const newValue = this.props.value;

    if (prevProps.value !== newValue) {
      if (newValue === "" || newValue === null || newValue === undefined) {
        this.setState({ value: 0 });
      } else {
        this.setState({ value: newValue });
      }
    }
  }

  get maxLength() {
    const { max, places } = this.props;

    return max.toLocaleString('pt-BR', { minimumFractionDigits: places }).length;
  }
  get maxLengthDefault() {
    return N.MAX_DECIMAL.toString().length;
  }

  isDecimalNumber(value) {
    return !isNaN(value) && value.toString().includes('.'); 
  }

  onKeyDown(event) {
    if (this.props.onKeyDown) this.props.onKeyDown(event);

    if (this.state.value == undefined)
      this.setState({ value: 0 });
  
    if (event.key === '-' && this.props.allowNegative && this.state.value !== 0) {
      const newValue = `${this.state.value}`.startsWith('-')
        ? `${this.state.value}`.slice(1)
        : `-${this.state.value}`;
      const floatValue = this.isDecimalNumber(newValue) ? parseFloat(newValue) : newValue;
  
      setTimeout(() => {
        this.setState({ value: floatValue }, () => {
          this.handleChange(event, floatValue);
        });
      }, 100);
    }
  }

  render() {
    const {
      className,
      places,
      allowNegative,
      onBlur,
      placeHolder,
      disabled,
      title,
      tamanho,
      max,
      name,
      prefix,
      suffix,
      inputRef
    } = this.props;

    return (
      <CurrencyInput
        ref={inputRef}
        name={name}
        className={className || 'form-control'}
        decimalSeparator=','
        thousandSeparator='.'
        precision={places}
        selectAllOnFocus={true}
        allowNegative={allowNegative}
        value={this.state.value === undefined ? this.props.value : this.state.value}
        onChangeEvent={this.handleChange.bind(this)}
        onBlur={onBlur}
        placeholder={placeHolder}
        disabled={disabled}
        maxLength={max ? this.maxLength : tamanho ? tamanho : this.maxLengthDefault}
        allowEmpty={true}
        title={title}
        onKeyDown={this.onKeyDown}
        prefix={prefix}
        suffix={suffix}
      />
    );
  }
}

DecimalInput.defaultProps = {
  places: 2,
};

export default DecimalInput;
